export type AuthoringSchema = {
  allowSections: boolean;
  allowSubSections: boolean;
  allowedBlocks: Array<"paragraph" | "bulletList" | "figure" | "note">;
};

export const authoringSchema: AuthoringSchema = {
  allowSections: true,
  allowSubSections: true,
  allowedBlocks: ["paragraph", "bulletList", "figure", "note"],
};
